import ColorIQHistory from 'components/Header/BeautyPreferences/ColorIQHistory/ColorIQHistory';
import { withColorIQHistoryProps } from 'viewModel/header/beautyPreferences/colorIQHistory/withColorIQHistoryProps';

const ConnectedColorIQHistory = withColorIQHistoryProps(ColorIQHistory);

export default ConnectedColorIQHistory;
